export var getTypography = function (breakpoints) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return ({
        fontFamily: "'Nunito', sans-serif",
        fontWeightRegular: 400,
        fontWeightMedium: 600,
        fontWeightBold: 700,
        h1: (_a = {
                fontWeight: 400,
                lineHeight: 'normal',
                fontSize: 60
            },
            _a[breakpoints.down('sm')] = {
                fontSize: 24,
            },
            _a[breakpoints.between('sm', 'md')] = {
                fontSize: 32,
            },
            _a),
        h2: (_b = {
                fontWeight: 400,
                lineHeight: 'normal',
                fontSize: 48
            },
            _b[breakpoints.down('sm')] = {
                fontSize: 20,
            },
            _b[breakpoints.between('sm', 'md')] = {
                fontSize: 28,
            },
            _b),
        h3: (_c = {
                fontWeight: 400,
                lineHeight: 'normal',
                fontSize: 28
            },
            _c[breakpoints.down('sm')] = {
                fontSize: 18,
            },
            _c[breakpoints.between('sm', 'md')] = {
                fontSize: 22,
            },
            _c),
        h4: (_d = {
                fontWeight: 400,
                lineHeight: 'normal',
                fontSize: 24
            },
            _d[breakpoints.down('sm')] = {
                fontSize: 16,
            },
            _d[breakpoints.between('sm', 'md')] = {
                fontSize: 20,
            },
            _d),
        h5: (_e = {
                fontWeight: 700,
                lineHeight: 'normal',
                fontSize: 20
            },
            _e[breakpoints.down('sm')] = {
                fontSize: 14,
            },
            _e[breakpoints.between('sm', 'md')] = {
                fontSize: 17,
            },
            _e),
        h6: (_f = {
                fontWeight: 700,
                lineHeight: 'normal',
                fontSize: 16
            },
            _f[breakpoints.down('sm')] = {
                fontSize: 13,
            },
            _f[breakpoints.between('sm', 'md')] = {
                fontSize: 14.5,
            },
            _f),
        subtitle1: (_g = {
                fontWeight: 700,
                lineHeight: 'normal',
                fontSize: 14
            },
            _g[breakpoints.down('sm')] = {
                fontSize: 12,
            },
            _g[breakpoints.between('sm', 'md')] = {
                fontSize: 13,
            },
            _g),
        subtitle2: (_h = {
                fontWeight: 700,
                lineHeight: 'normal',
                fontSize: 12
            },
            _h[breakpoints.down('sm')] = {
                fontSize: 10,
            },
            _h[breakpoints.between('sm', 'md')] = {
                fontSize: 11,
            },
            _h),
        body1: (_j = {
                lineHeight: 'normal',
                fontSize: 16,
                fontWeight: 400
            },
            _j[breakpoints.down('sm')] = {
                fontSize: 13,
            },
            _j[breakpoints.between('sm', 'md')] = {
                fontSize: 14.5,
            },
            _j),
        body2: (_k = {
                lineHeight: 'normal',
                fontSize: 14,
                fontWeight: 400
            },
            _k[breakpoints.down('sm')] = {
                fontSize: 12,
            },
            _k[breakpoints.between('sm', 'md')] = {
                fontSize: 13,
            },
            _k),
        caption: (_l = {
                lineHeight: 'normal',
                fontSize: 12,
                fontWeight: 400
            },
            _l[breakpoints.down('sm')] = {
                fontSize: 10,
            },
            _l[breakpoints.between('sm', 'md')] = {
                fontSize: 11,
            },
            _l),
        overline: (_m = {
                fontWeight: 500,
                lineHeight: 'normal',
                fontSize: 10,
                textTransform: 'capitalize'
            },
            _m[breakpoints.down('sm')] = {
                fontSize: 8,
            },
            _m[breakpoints.between('sm', 'md')] = {
                fontSize: 9,
            },
            _m),
    });
};
